
        import 'InfoPanels.4685a1d.css-module'
        export default {"infoPanels":"infoPanels_InfoPanels_4685a1d","yourPlanInfoPanels":"yourPlanInfoPanels_InfoPanels_4685a1d","billingInfoPanels":"billingInfoPanels_InfoPanels_4685a1d"}
    